import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { IonContent, IonHeader, IonToolbar, IonButtons, IonButton, IonItem, IonLabel, modalController, IonInput } from '@ionic/vue';
import { onMounted, watch } from 'vue';
import { useMedia } from '@/stores/media';
import VoiceTalent from '@/views/form/VoiceTalent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectionModal',
  setup(__props) {

const media = useMedia();

const cancel = () => {
  return modalController.dismiss(null, 'cancel');
};

watch(
  media.filter,
  async () => {
    await media.getVoices();
  },
  {
    deep: true,
  }
);

onMounted(async () => {
  if (!media.voices.length) {
    await media.getVoices();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), { position: "stacked" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Search for voice:")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonInput), {
                  placeholder: "Input name...",
                  class: "text-sm",
                  inputmode: "search",
                  modelValue: _unref(media).filter['filter[name]'],
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(media).filter['filter[name]']) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(media)?.meta?.links, (link) => {
                  return (_openBlock(), _createBlock(_unref(IonButton), {
                    color: link.active ? 'primary' : 'medium',
                    onClick: ($event: any) => (_unref(media).paginate(link)),
                    key: link.label,
                    disabled: _unref(media).linkDisabled(link)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: _unref(media).linkLabel(link)
                      }, null, 8, _hoisted_1)
                    ]),
                    _: 2
                  }, 1032, ["color", "onClick", "disabled"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButtons), { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  color: "medium",
                  onClick: cancel,
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancel")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), { class: "ion-padding" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(media).voices, (voice) => {
          return (_openBlock(), _createBlock(VoiceTalent, {
            key: voice.id,
            voice: voice
          }, null, 8, ["voice"]))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}
}

})